import React from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { useHandleFilter, useHandleFilterType } from '@catalogo/ui-americanas-desktop-product-review/src/hooks';

const withFilters = (Component: any) => (props: any) => {
  const { queryParam } = React.useContext<any>(context);
  const { handleFilter } = useHandleFilter();
  const { handleFilterType } = useHandleFilterType();
  const cleanFilters = () => {
    handleFilter({ rating: [] });
    handleFilterType({ badges: null });
  };
  const filterVerified = () => {
    switch (queryParam.badges) {
      case 'verified_purchaser':
        handleFilterType({ badges: null });
        break;
      case null:
        handleFilterType({ badges: 'verified_purchaser' });
        break;
      case 'skoob':
        handleFilterType({ badges: 'verified_purchaser' });
        break;
      default:
        handleFilterType({ badges: 'verified_purchaser' });
    }
  };
  const filterSkoob = () => {
    switch (queryParam.badges) {
      case 'verified_purchaser':
        handleFilterType({ badges: 'skoob' });
        break;
      case null:
        handleFilterType({ badges: 'skoob' });
        break;
      case 'skoob':
        handleFilterType({ badges: null });
        break;
      default:
        handleFilterType({ badges: 'skoob' });
    }
  };

  return (
    <Component
      cleanFilters={cleanFilters}
      handleFilter={handleFilter}
      handleFilterType={handleFilterType}
      filterVerified={filterVerified}
      filterSkoob={filterSkoob}
      queryParam={queryParam}
      {...props}
    />
  );
};

export default withFilters;
export { withFilters };
